import React from 'react'
import PropTypes from 'prop-types'

import BasicViewComponent from './BasicViewComponent'
import I18N from '../../utils/I18nMessageProvider'

const WEEKDAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'
]

class Hours extends BasicViewComponent {

  constructor (props) {
    super(props)
    this.id = Math.random().toString(36).substr(2, 5)
  }

  renderOpeningHoursPerDay () {
    const hours = this.evalConfigValue(this.props.config.value)

    // console.log({hours, config: this.props.config, eval: this.evalConfigValue(this.props.config.value)})

    if (!hours) {
      return null
    }

    return WEEKDAYS.map(weekday => {
      if (hours[weekday]) {
        let dayHours = hours[weekday].times.map(dayHour => {
          return `${dayHour.open_time} - ${dayHour.close_time}`
        }).join(', ')

        if (!dayHours) {
          dayHours = I18N.get('tripproxy.poiPane.closed')
        }

        return (
          <tr key={weekday}>
            <td className='openingtimes_weekday'>{hours[weekday].name}</td>
            <td>{dayHours}</td>
          </tr>
        )
      }
      return null
    })
  }

  render () {
    if (!super.conditionsAreMet()) {
      return null
    }

    return (
      <span
        className={this.cssClass}
        onTouchTap={this.onTouchTap}
      >
        <table>
          <tbody>
            {this.renderOpeningHoursPerDay()}
          </tbody>
        </table>
      </span>
    )
  }

}

Hours.TYPE = 'hours'

Hours.propTypes = {
  config: PropTypes.object.isRequired,
}

export default Hours



// WEBPACK FOOTER //
// ./src/components/ViewComponents/Hours.js